// Minnesotaänger Mini App — boot diagnostics helpers.
// 与 public/boot-diag.js（ES5 启动探针）配套：探针未加载（如某些测试环境）
// 时全部为 no-op，不影响正常启动。

export function setBootStage(stage: string, detail?: string | number): void {
  (window as any).__miniappSetBootStage?.(stage, detail === undefined ? undefined : String(detail));
}

export function getBootStage(): string {
  return (window as any).__MINIAPP_BOOT_STAGE__ || 'html';
}

export function conversationsEnded(stage: string): boolean {
  return stage === 'conversations-loaded' || stage === 'ready'
    || stage.startsWith('conversations-error:')
    || stage.startsWith('conversations-loaded:');
}
